import React, {Component} from "react";
import {injectIntl} from "react-intl";
import axios from "axios";
//import {browserHistory} from "react-router";
import styles from 'style/main.less'
import style from './index.less'

import {Button, Modal, Input, Spin, message} from 'antd';
import {Icon,Form} from "@ant-design/compatible"
import PasswordStrengthComponent from "./PasswordStrengthComponent";
import {connect} from "react-redux";
import {LOGIN, LOGOUT} from "reducers/authenticationNew";
const FormItem = Form.Item;
function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class Register extends Component {

  state = {
    loading: false,
    confirmDirty: false,
    validationCodeSent: false,
    validationCodeTimeLeft: 120, // seconds
    submitError: false,
    // remove:false,
    oldUser:false,
    visible:false,
    formValue:"",

  };
componentDidMount() {
  //
  // axios({
  //   url: `/api-user/users?userId=`+this.props.userId,
  //   method: "Get"
  // }).then(
  //   response => {
  //     console.debug("Register: check username", response.data.remove);
  //     this.setState({remove:response.data.remove})
  //   }
  // ).catch(
  //   err => {
  //     console.error("Register: submit form", err);
  //   }
  // )
}
//注册流程
  handleSubmitOk=(values)=>{
    axios({
      // url: "/api-user/users",
      url: "/backendUsers/",
      method: "POST",
      data: {
        email: values.email,
        phone: values.phone,
        password: values.password,
        username: values.username
      }
    }).then(
      response => {
        this.props.dispatch({
          type: "UPDATE_EMAIL",
          data: values.email
        });

        this.setState({
          loading: false
        });

        this.props.history.push('/common/register-success');
      }
    ).catch(
      err => {
        console.error("Register: submit form", err);
      }
    )
  }

  handleSubmit = (e) => {

    e.preventDefault();
    this.setState({
      loading: false
    });
    this.props.form.validateFields((err, values) => {
      this.setState({
        formValue:values
      })
      if (!err) {
        console.debug("Register: submit form", err, values);
        axios({
          url: `/api-user/checkOldUser?phone=`+values.phone+`&email=`+values.email,
          method: "post"
        }).then(
          response => {
            console.debug("Register: check checkOldUser", response.data);
            this.setState({oldUser:response.data})
            if(response.data){
              Modal.info({
                title: 'This is a notification message',
                content: `检测到你曾为本平台用户，可选择恢复原账号信息`,
                onOk:()=>{this.setState({visible:true})}
              });
            }else{
              this.handleSubmitOk(values)
            }
          }
        ).catch(
          err => {
            console.error("Register: submit form", err);
          }
        )
      }else {
        console.error("Register: validate form: ", err, values);
        this.setState({
          loading: false
        })
      }
      this.setState({
        submitError: !!err
      })
    });
  };

  handleConfirmBlur = (e) => {
    const value = e.target.value;
    this.setState({confirmDirty: this.state.confirmDirty || !!value});
  };

  checkConfirm = (rule, value, callback, errTxt) => {
    const form = this.props.form;
    console.debug("Register: check password", form.getFieldValue("password"));
    if (value && this.state.confirmDirty) {
      form.validateFields(['confirm'], {force: true});
    }
    if(value && value === form.getFieldValue('username')){
      callback(errTxt);
    }
    callback();
  };

  checkPassword = (rule, value, callback, errTxt) => {
    const form = this.props.form;
    console.debug("Register: check confirm", form.getFieldValue("confirm"));
    if (value && value !== form.getFieldValue('password')) {
      callback(errTxt);
    } else {
      callback();
    }
  };

  checkUsername = (rule, value, callback, errTxt) => {
    const form = this.props.form;
    if (value) {
      axios({
        url: `/api-user/usernameUnique/${value}`,
        method: "POST"
      }).then(
        response => {
          console.debug("Register: check username", response.data);
          if (!response.data) {
            // if(true){
            //   callback()
            // }
            callback(errTxt)
          } else {
            callback()
          }
        }
      )
    } else {
      callback()
    }
  };

  checkEmail = (rule, value, callback, errTxt) => {
    const form = this.props.form;
    if (value) {
      axios({
        url: `/api-user/emailUnique/${value}`,
        method: "POST"
      }).then(
        response => {
          console.debug("Register: check email", response.data);
          if (!response.data) {
            callback(errTxt)
          } else {
            callback()
          }
        }
      )
    } else {
      callback()
    }
  };

  checkPhone = (rule, value, callback, errTxt) => {
    const form = this.props.form;
    if (value) {
      axios({
        url: `/api-user/phoneUnique/${value}`,
        method: "POST"
      }).then(
        response => {
          console.debug("Register: check phone", response.data);
          if (!response.data) {
            callback(errTxt)
          } else {
            callback()
          }
        }
      )
    } else {
      callback();
    }
  };

  sendValidationCode = () => {
    const form = this.props.form;
    const phone = form.getFieldValue("phone");
    if (phone) {
      axios({
        url: `/api-user/verificationCodes?phone=${phone}`,
        method: "GET"
      }).then(
        response => {
          console.debug("response", response.data);
          if (response.status === 200) {
            this.timer = setInterval(() => this.tick(), 1000);
            this.setState({
              validationCodeSent: true,
              validationCodeTimeLeft: 120
            })
          }
        }
      ).catch(
        err => {
          console.error("Register: get validation code");
        }
      )
    }
  };

  tick = () => {
    let count = this.state.validationCodeTimeLeft > 0 ?
      this.state.validationCodeTimeLeft - 1 : 0;
    this.setState({
      validationCodeTimeLeft: count
    });

    if (count === 0) {
      this.setState({
        validationCodeSent: false
      });
      clearInterval(this.timer)
    }
  };

  checkValidationCode = (rule, value, callback, errTxt) => {
    const form = this.props.form;
    const phone = form.getFieldValue("phone");
    if (value === null || value === undefined || value.length !== 5) {
      callback(errTxt);
    }
    axios({
      url: `/api-user/verificationCodesCheck/${value}?phone=${phone}`,
      method: "POST"
    }).then(
      response => {
        callback();
      }
    ).catch(
      err => callback(err.data.reason)
    )
  };
  //恢复员账号
  handleOk = () => {
    // let url="/api-user/updateRemove?userId="+this.props.userId;
    const form=this.props.form
    let  url= "/api-user/updateRemoveFlag?phone="+form.getFieldValue("phone")+"&email="+form.getFieldValue("email");
    axios({
      method: "post",
      url: url,
      contentType: "application/json",
      withCredentials: true,
    }).then(
      response => response.data,
    ).then(
      response => {
        console.log(response);
        message.success("账号恢复成功");
        this.props.handleLoginClick();
      }
    ).catch(
      ex => {
        console.log(ex);
        message.error("账号恢复失败");
      })
  };
//取消
  handleCancel = (values) => {
    this.setState({
      visible:false
    })
   this.handleSubmitOk(values)
  };
  render() {

    const passwordNotSame = this.language("user_service_register_password_not_same");
    const usernameNotUnique = this.language("user_service_register_username_not_unique");
    const emailNotUnique = this.language("user_service_register_email_not_unique");
    const phoneNotUnique = this.language("user_service_register_phone_not_unique");
    const validationCodeFail = this.language("user_service_register_validation_code_fail");
    const getValidationCode = this.language("user_service_register_get_validation_code");
    const validationCountDown = this.language("user_service_register_validation_code_count_down");
    const registerTitle = this.language("user_service_register_title");
    const submitError = this.language("user_service_register_submit_error");
    const usernameCheck = this.language("user_service_register_username_check");
    const usernamePlaceholder = this.language("user_service_register_username_placeholder");
    const emailCheck = this.language("user_service_register_email_check");
    const emailCheckTwo = this.language("user_service_register_email_check_two");
    const emailPlaceholder = this.language("user_service_register_email_placeholder");
    const phoneCheck = this.language("user_service_register_phone_check");
    const phoneCheckTwo = this.language("user_service_register_phone_check_two");
    const phonePlaceholder = this.language("user_service_register_phone_placeholder");
    const codeCheck = this.language("user_service_register_code_check");
    const codePlaceholder = this.language("user_service_register_code_placeholder");
    const passwordCheck = this.language("user_service_register_password_check");
    const passwordCheckTwo = this.language("user_service_register_password_check_two");
    const passwordPlaceholder = this.language("user_service_register_password_placeholder");
    const confirmCheck = this.language("user_service_register_confirm_check");
    const confirmPlaceholder = this.language("user_service_register_confirm_placeholder");
    const registerSubmit = this.language("user_service_register_submit_btn");
    const passwordUsernameSame = this.language("user_service_register_password_username_same");

    const {getFieldDecorator} = this.props.form;

    console.debug("render: register", this.state);

    let passwordStrengthTips = null;
    if (this.props.form.getFieldValue("password") !== "" &&
      this.props.form.getFieldValue("password") !== undefined) {
      passwordStrengthTips = (
        <div className={styles["bubble"]}>
          <PasswordStrengthComponent
            password={this.props.form.getFieldValue("password")}/>
        </div>
      )
    }

    let validationCodeBtn = (
      <Button
        type="primary"
        style={{width: "50%"}}
        disabled={!/^[1](([3][0-9])|([4][5-9])|([5][0-3,5-9])|([6][5,6])|([7][0-8])|([8][0-9])|([9][1,8,9]))[0-9]{8}$/.test(this.props.form.getFieldValue("phone"))}
        onClick={this.sendValidationCode}
      >
        {getValidationCode}
      </Button>
    );

    if (this.state.validationCodeSent) {
      validationCodeBtn = (
        <Button
          type="primary"
          style={{width: "50%"}}
          disabled
        >
          {`${this.state.validationCodeTimeLeft}${validationCountDown}`}
        </Button>
      )
    }

    return (
      <div style={{
        background: "rgb(236,236,236)",
        height: "100vh",
        padding: "24px"}}
      className={style.formClass}
      >
        <Spin spinning={this.state.loading} size="large">
          <div style={{
            width: "500px",
            margin: "16px auto",
            background: "white",
            padding: "24px",
            borderRadius: "4px"
          }}>
            <h2 style={{
              textAlign: "center",
              marginBottom: "16px"
            }}>{registerTitle}</h2>
            {
              this.state.submitError &&
              <div style={{
                border: "1px solid #f5222d",
                borderRadius: "4px",
                color: "#f5222d",
                padding: "16px",
                marginBottom: "16px",
                textAlign: "center"
              }}>
                {submitError}
              </div>
            }
            <Form onSubmit={this.handleSubmit}>
              <FormItem>
                {
                  getFieldDecorator('username', {
                    getValueFromEvent: (e) => {
                      return e.target.value;
                    },
                    rules: [
                      {
                        pattern:/^[^#]{1,31}$/,
                        message: "不得包含特俗字符#号、且长度不能超过31位",
                      },
                      {required: true, message: usernameCheck},
                      {validator: (rule, value, callback) => this.checkUsername(rule, value, callback,usernameNotUnique)}
                    ],
                  })(
                    <Input
                      prefix={<Icon type="user"
                                    style={{color: 'rgba(0,0,0,.25)'}}/>}
                      placeholder={usernamePlaceholder}
                    />

                  )
                }
              </FormItem>
              <FormItem>
                {
                  getFieldDecorator('email', {
                    getValueFromEvent: (e) => {
                      return e.target.value;
                    },
                    rules: [
                      {type: 'email', message: emailCheck},
                      {required: true, message: emailCheckTwo},
                      {validator: (rule, value, callback) => this.checkEmail(rule, value, callback, emailNotUnique)}
                    ]
                  })(
                    <Input
                      prefix={<Icon type="global"
                                    style={{color: 'rgba(0,0,0,.25)'}}/>}
                      placeholder={emailPlaceholder}/>
                  )
                }
              </FormItem>
              <FormItem>
                {
                  getFieldDecorator('phone', {
                    getValueFromEvent: (e) => {
                      return e.target.value;
                    },
                    rules: [
                      {
                        pattern: /^[1](([3][0-9])|([4][5-9])|([5][0-3,5-9])|([6][5,6])|([7][0-8])|([8][0-9])|([9][1,8,9]))[0-9]{8}$/,
                        message: phoneCheck,
                      },
                      {required: true, message: phoneCheckTwo},
                      {validator: (rule, value, callback) => this.checkPhone(rule, value, callback, phoneNotUnique)}
                    ]
                  })(
                    <Input
                      prefix={<Icon type="mobile"
                                    style={{color: 'rgba(0,0,0,.25)'}}/>}
                      placeholder={phonePlaceholder}/>
                  )
                }
              </FormItem>
              <FormItem>
                {
                  getFieldDecorator('code', {
                    getValueFromEvent: (e) => {
                      return e.target.value;
                    },
                    rules: [
                      {required: true, message: codeCheck},
                      {validator: (rule, value, callback) => this.checkValidationCode(rule, value, callback, validationCodeFail)}

                    ],
                  })(
                    <div style={{display: "flex"}}>
                      <Input
                        style={{marginRight: "16px"}}
                        prefix={<Icon type="solution"
                                      style={{color: 'rgba(0,0,0,.25)'}}/>}
                        placeholder={codePlaceholder}
                      />
                      {validationCodeBtn}
                    </div>
                  )
                }
              </FormItem>
              <FormItem>
                {
                  getFieldDecorator('password', {
                    rules: [
                      {
                        // pattern: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,20}$/,
                        pattern: /^((?=.*[A-Za-z])(?=.*\d)|(?=.*[A-Za-z])(?=.*_)|(?=.*\d)(?=.*_))[a-zA-Z0-9_]{8,20}$/,
                        message: passwordCheck
                      },
                      {required: true, message: passwordCheckTwo},
                      {validator: (rule, value, callback) => this.checkConfirm(rule, value, callback, passwordUsernameSame)}
                    ],
                  })(
                    <div>
                      <Input
                        style={{position: "relative"}}
                        prefix={<Icon type="lock"
                                      style={{color: 'rgba(0,0,0,.25)'}}/>}
                        type="password" placeholder={passwordPlaceholder}/>
                      {passwordStrengthTips}
                    </div>
                  )
                }
              </FormItem>
              <FormItem>
                {
                  getFieldDecorator('confirm', {
                    rules: [
                      {required: true, message: confirmCheck},
                      {validator: (rule, value, callback) => this.checkPassword(rule, value, callback, passwordNotSame)}
                    ],
                  })(
                    <Input
                      prefix={<Icon type="lock"
                                    style={{color: 'rgba(0,0,0,.25)'}}/>}
                      type="password"
                      placeholder={confirmPlaceholder}
                      onBlur={this.handleConfirmBlur}
                    />
                  )
                }
              </FormItem>
              <FormItem style={{display:'flex',justifyContent:'center'}}>
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{width: "450px",textAlign:'center'}}
                >
                  {registerSubmit}
                </Button>
              </FormItem>
            </Form>

          </div>
          <Modal
            title="Title"
            visible={this.state.visible}
            onOk={this.handleOk}
            onCancel={()=>this.handleCancel(this.state.formValue)}
          >
            <p style={{color:'red'}}>点击确定将恢复原账号，取消则进入重新注册流程</p>
          </Modal>
        </Spin>
      </div>
    );
  }

  language(value) {
    return this.props.intl.formatMessage({id: value});
  }
}

export const registerReducer = (state = {
  email: ""
}, action) => {
  switch (action.type) {
    case "UPDATE_EMAIL":
      return {
        ...state,
        email: action.data
      };
    default:
      return state
  }
};

class RegisterContainer extends Component {

  render() {
    return <Register {...this.props}/>
  }
}

export const mapStateToProps = (state) => {
  return {
    ...state

  }
};

export const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    handleLogoutClick:()=>{
      dispatch({type: LOGOUT});
    },
    handleLoginClick:()=>{
      dispatch({type: LOGIN});
    },
  }
};


const WrappedHorizontalRegisterForm = Form.create()(connect(mapStateToProps, mapDispatchToProps)(injectIntl(Register)));

export default WrappedHorizontalRegisterForm;
